import { JsonFormat, stringJsonFormat } from "@redotech/json/format";
import { TriggerType } from "./trigger-enums";

export const triggerTypeJsonFormat: JsonFormat<TriggerType> =
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  stringJsonFormat as JsonFormat<TriggerType>;
